<template>
	<div>
		<b-img src="/images/importer/rig-requirements/rig.jpg"></b-img>
		<p>
			This tutorial will go over some of the rig requirements for character models in FarmD. There aren't very many strict requirements for the characters' rigs themselves - 
			the more important thing is proportions. If your character has a long torso, or a big head or hands, you may end up with some awkward or broken-looking animations 
			when you load them into the game. It's best for anthro characters to have mostly humanoid proportions, and there is a scale reference in the Basic Info module of the Character Importer 
			so you can see how your character compares to what is expected in the game.
		</p>

		<p>
			Currently the only place where the orientations of your character's bones are important are those in the tail. If you set up a tail using the Tail module, which means it
			will have physics and will collide and interact with objects in the world, there are some guidelines for the tail bones in order for things to work correctly. This is because 
			there are animations for the tail waving and curling that are handled by the game. If you don't use the Tail module and want to have your own keyframed animations for the tail,
			or use dynamic bones, then your tail bones can be set up however you like.
		</p>
        
		<b-img src="/images/importer/rig-requirements/tail.jpg"></b-img>
		<p>
			In the anthro example scene, you can see the orientation that tail bones should have - with the local Y-Axis (green) pointing along the length of the tail, the Z-Axis (blue) pointing upward 
			relative to the tail, and the X-Axis (red) pointing to the left if you're looking away from the character's body. This should be the same for all bones in the tail - that way, if your 
			character's tail needs to curl to the right for an animation, all the bones will be rotated correctly. If the tail bones aren't oriented this way, or are inconsistent with each 
			other, you can end up with issues where it gets kinked up or doesn't behave as expected.
		</p>
	</div>
</template>

<script>
export default {
	name: 'RigRequirements',
}
</script>
